import React, { useEffect, useState } from 'react'
import { SimpleSubTitleCard, SimpleTitleCard } from 'styles/global'
import {
  ButtonConfigKanban,
  CardBigNumberSla,
  CardSLAConfigurado,
  Info,
  Titulo
} from '../../style'
import { AiOutlineClose, AiOutlinePlusCircle } from 'react-icons/ai'
import { Card, Col, Label, Row } from 'reactstrap'
import { FiSave, FiTrash } from 'react-icons/fi'
import InputCustom from 'components/Inputs'
import CustomSelect from 'components/Select'
import { IconButton, Tooltip } from '@mui/material'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import {
  CONFIGURACAO_KANBAN,
  InvalidsRegisterSLAs,
  RegisterSLAs,
  RegraEscalacao
} from 'store/modules/backoffice/configuracaoKanban/types'
import useRedux from 'hooks/useRedux'
import * as configuracaoKanbanActions from 'store/modules/backoffice/configuracaoKanban/actions'
import { maskNumber } from 'util/masks'
import { MdOutlineWatchLater } from 'react-icons/md'
import { GoAlert } from 'react-icons/go'
import { toast } from 'react-toastify'
import { schemaSLAs } from '../../constants/schemas'
import * as yup from 'yup'
import ModalExclusao from 'components/ModalExclusao'
import PrivateComponent from 'components/PrivateComponent'
import moment from 'moment'

const SLAs = () => {
  const { tabSLAs, activeTab } = useSelector<
    ApplicationState,
    CONFIGURACAO_KANBAN
  >((state) => state.configuracaoKanban)

  const { dispatch } = useRedux()

  const [selectedId, setSelectedId] = useState('')

  type RegisterFields = keyof RegisterSLAs
  function onChange<T extends RegisterFields>(
    value: RegisterSLAs[T],
    field: T
  ) {
    dispatch(configuracaoKanbanActions.setRegisterFieldsTabSLAs(value, field))
  }

  type RegraEscalacaoFields = keyof RegraEscalacao
  function onChangeRegrasEscalacao<T extends RegraEscalacaoFields>(
    value: RegraEscalacao[T],
    field: T,
    index: number
  ) {
    dispatch(
      configuracaoKanbanActions.setRegisterRegrasEscalacaoTabSLAs(
        value,
        field,
        index
      )
    )
  }

  function onRemoveRegraEscalacao(index: number) {
    dispatch(
      configuracaoKanbanActions.removerRegisterRegrasEscalacaoTabSLAs(index)
    )
  }

  const onSave = () => {
    dispatch(configuracaoKanbanActions.cleanInvalidsRegisterTabSLAs())
    schemaSLAs
      .validate(tabSLAs.register, { abortEarly: false })
      .then(() => {
        if (tabSLAs.register?.id) {
          dispatch(configuracaoKanbanActions.editarSlaTabSLAsSaga())
        } else {
          dispatch(configuracaoKanbanActions.salvarSlaTabSLAsSaga())
        }
      })
      .catch((err: yup.ValidationError) => {
        console.log(err.inner)
        err.inner.forEach((error) => {
          if (error.path === 'regrasEscalacao') {
            dispatch(
              configuracaoKanbanActions.setInvalidsFieldsRegisterTabSLAs(
                {
                  invalid: true,
                  message: error.message
                },
                'regrasEscalacaoMessage'
              )
            )
          } else if (error.path?.includes('[')) {
            const e1 = error.path?.split('[')
            const e2 = error.path?.match(/\[(.*?)\]/) || []
            const e3 = error.path?.split('.')
            if (error.path) {
              dispatch(
                configuracaoKanbanActions.setInvalidsArrayFieldRegisterTabSLAs(
                  {
                    invalid: true,
                    message: error.message
                  },
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  //@ts-ignore disable-next-line
                  e1[0],
                  Number(e2[1]),
                  e3[1]
                )
              )
            }
          } else {
            dispatch(
              configuracaoKanbanActions.setInvalidsFieldsRegisterTabSLAs(
                {
                  invalid: true,
                  message: error.message
                },
                error.path as keyof InvalidsRegisterSLAs
              )
            )
          }
        })
        toast.warning('Por favor, verifique os campos inválidos.')
      })
  }

  useEffect(() => {
    if (activeTab === 2) {
      dispatch(configuracaoKanbanActions.getSLAsConfiguradosTabSLAsSaga())
      dispatch(configuracaoKanbanActions.getPipelinesTabSLAsSaga())
      dispatch(configuracaoKanbanActions.getBigNumbersTabSLAsSaga())
      // dispatch(configuracaoKanbanActions.getAcoesTabSLAsSaga())
    }
  }, [dispatch, activeTab])

  useEffect(() => {
    if (activeTab === 2 && tabSLAs.register?.pipelineId) {
      dispatch(configuracaoKanbanActions.getEtapasTabSLAsSaga())
    }
  }, [dispatch, activeTab, tabSLAs.register?.pipelineId])

  function formatarPrazoSla(minutos: number) {
    if (!minutos || minutos <= 0) return '-'
    const duracao = moment.duration(minutos, 'minutes')
    const dias = Math.floor(duracao.asDays())
    const horas = duracao.hours()
    const mins = duracao.minutes()
    const partes: string[] = []
    if (dias) partes.push(`${dias}d`)
    if (horas) partes.push(`${horas}h`)
    if (mins) partes.push(`${mins}min`)
    return partes.join(' ')
  }

  function novoSla() {
    dispatch(
      configuracaoKanbanActions.setRegisterTabSLAs({
        id: '',
        nome: '',
        descricao: '',
        pipelineId: '',
        pipelineEtapaId: '',
        prazo: 0,
        regrasEscalacao: []
      })
    )
    dispatch(
      configuracaoKanbanActions.setInvalidsRegisterTabSLAs({
        id: { invalid: false, message: '' },
        nome: { invalid: false, message: '' },
        descricao: { invalid: false, message: '' },
        pipelineId: { invalid: false, message: '' },
        pipelineEtapaId: { invalid: false, message: '' },
        prazo: { invalid: false, message: '' },
        regrasEscalacaoMessage: { invalid: false, message: '' },
        regrasEscalacao: []
      })
    )
  }

  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <SimpleTitleCard className="pb-0">
            Configuração de SLAs
          </SimpleTitleCard>
          <SimpleSubTitleCard>
            Configure prazos e alertas para suas etapas
          </SimpleSubTitleCard>
        </div>
        <PrivateComponent screen="configuracaoKanban" typeActions="gravar">
          <div>
            <ButtonConfigKanban className="btn-blue" onClick={novoSla}>
              <AiOutlinePlusCircle />
              <span>Novo SLA</span>
            </ButtonConfigKanban>
          </div>
        </PrivateComponent>
      </div>
      <Row className="d-flex row-gap-20">
        <Col className="d-flex flex-column row-gap-20" md={6}>
          <Row className="d-flex row-gap-20">
            <Col md={6}>
              <CardBigNumberSla>
                <div className="d-flex align-items-center justify-content-between">
                  <label className="title">SLAs Ativos</label>
                  <MdOutlineWatchLater className="icon" />
                </div>
                <span className="informacao">
                  {tabSLAs.bigNumbers.prazosAtendimentosAtivos}
                </span>
              </CardBigNumberSla>
            </Col>
            <Col md={6}>
              <CardBigNumberSla>
                <div className="d-flex align-items-center justify-content-between">
                  <label className="title">Em Atraso</label>
                  <GoAlert className="icon" />
                </div>
                <span className="informacao">
                  {tabSLAs.bigNumbers.emAtrasoAtivos}
                </span>
              </CardBigNumberSla>
            </Col>
          </Row>
          <Card className="p-4">
            <div className="d-flex flex-column gap-2">
              <Titulo>SLAs Configurados</Titulo>
              {tabSLAs.slasConfigurados.map((sla) => (
                <CardSLAConfigurado
                  key={sla.id}
                  onClick={() => {
                    dispatch(
                      configuracaoKanbanActions.getSlaByIdTabSLAsSaga(sla.id)
                    )
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <div>
                      <h4 className="titulo">{sla.nome}</h4>
                      <span className="descricao">{sla.descricao}</span>
                    </div>
                    <PrivateComponent
                      screen="configuracaoKanban"
                      typeActions="deletar"
                    >
                      <div className="d-flex align-items-center gap-3">
                        <IconButton
                          onClick={() => {
                            setSelectedId(sla.id)
                          }}
                        >
                          <FiTrash className="icon-trash" />
                        </IconButton>
                      </div>
                    </PrivateComponent>
                  </div>
                  <div className="d-flex justify-content-between w-100 mt-3">
                    <Label className="infos">
                      Etapa: <span>{sla.descricaoEtapa}</span>
                    </Label>
                    <Label className="infos">
                      Prazo: <span>{formatarPrazoSla(sla.prazo)}</span>
                    </Label>
                  </div>
                  <div className="d-flex gap-3 w-100">
                    <div className="situacao-verde">
                      <label className="valor">{sla.emDia}</label>
                      <span>Em dia</span>
                    </div>
                    <div className="situacao-amarelo">
                      <label className="valor">{sla.alerta}</label>
                      <span>Alerta</span>
                    </div>
                    <div className="situacao-vermelho">
                      <label className="valor">{sla.atrasado}</label>
                      <span>Atrasado</span>
                    </div>
                  </div>
                </CardSLAConfigurado>
              ))}
            </div>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="p-4">
            {tabSLAs.register ? (
              <>
                <div className="d-flex justify-content-between align-items-center">
                  <Titulo>
                    {tabSLAs.register?.id ? 'Editar' : 'Novo'} SLA
                  </Titulo>
                  <PrivateComponent
                    screen="configuracaoKanban"
                    typeActions="gravar"
                  >
                    <div className="d-flex gap-2">
                      <ButtonConfigKanban
                        onClick={onSave}
                        className="btn-blue"
                        disabled={tabSLAs.visualizacao}
                      >
                        <FiSave />
                        <span>Salvar</span>
                      </ButtonConfigKanban>
                      <ButtonConfigKanban
                        onClick={() => {
                          dispatch(
                            configuracaoKanbanActions.cleanRegisterTabSLAs()
                          )
                        }}
                        className="btn-light"
                      >
                        <AiOutlineClose />
                      </ButtonConfigKanban>
                    </div>
                  </PrivateComponent>
                </div>
                <Row className="d-flex row-gap-15">
                  <Col md={12}>
                    <Label className="label-12">Nome do SLA</Label>
                    <InputCustom
                      type="text"
                      placeholder="Nome do SLA"
                      value={tabSLAs.register?.nome}
                      onChange={(e) => {
                        onChange(e.target.value, 'nome')
                      }}
                      invalid={tabSLAs.invalids.nome.invalid}
                      message={tabSLAs.invalids.nome.message}
                      disabled={tabSLAs.visualizacao}
                    />
                  </Col>
                  <Col md={12}>
                    <Label className="label-12">Descrição</Label>
                    <InputCustom
                      type="text"
                      placeholder="Descreva o objetivo deste SLA"
                      value={tabSLAs.register?.descricao}
                      onChange={(e) => {
                        onChange(e.target.value, 'descricao')
                      }}
                      invalid={tabSLAs.invalids.descricao.invalid}
                      message={tabSLAs.invalids.descricao.message}
                      disabled={tabSLAs.visualizacao}
                    />
                  </Col>
                  <Col md={12}>
                    <Label className="label-12">Pipeline</Label>
                    <CustomSelect
                      options={tabSLAs.pipelines}
                      placeholder="Selecione um pipeline"
                      value={tabSLAs.register?.pipelineId}
                      onChange={(e) => {
                        onChange(e, 'pipelineId')
                      }}
                      invalid={tabSLAs.invalids.pipelineId.invalid}
                      message={tabSLAs.invalids.pipelineId.message}
                      disabled={tabSLAs.visualizacao}
                      accessorLabel="nome"
                      accessorValue="id"
                    />
                  </Col>
                  <Col md={12}>
                    <Label className="label-12">Etapa</Label>
                    <CustomSelect
                      options={tabSLAs.etapas}
                      placeholder="Selecione uma etapa"
                      value={tabSLAs.register?.pipelineEtapaId}
                      onChange={(e) => {
                        onChange(e, 'pipelineEtapaId')
                      }}
                      invalid={tabSLAs.invalids.pipelineEtapaId.invalid}
                      message={tabSLAs.invalids.pipelineEtapaId.message}
                      disabled={tabSLAs.visualizacao}
                      accessorLabel="nome"
                      accessorValue="id"
                    />
                  </Col>
                  <Col md={12}>
                    <Label className="label-12">Prazo (minutos)</Label>
                    <InputCustom
                      placeholder="Digite aqui"
                      value={tabSLAs.register?.prazo}
                      onChange={(e) => {
                        onChange(Number(maskNumber(e.target.value)), 'prazo')
                      }}
                      invalid={tabSLAs.invalids.prazo.invalid}
                      message={tabSLAs.invalids.prazo.message}
                      disabled={tabSLAs.visualizacao}
                    />
                  </Col>
                  <Col className="d-flex justify-content-between" md={12}>
                    <Label className="label-12">Regras de Escalação</Label>
                    <PrivateComponent
                      screen="configuracaoKanban"
                      typeActions="gravar"
                    >
                      <ButtonConfigKanban
                        className="btn-light"
                        onClick={() => {
                          dispatch(
                            configuracaoKanbanActions.adicionarRegisterRegrasEscalacaoTabSLAs()
                          )
                        }}
                        disabled={tabSLAs.visualizacao}
                      >
                        <AiOutlinePlusCircle />
                        <span>Adicionar</span>
                      </ButtonConfigKanban>
                    </PrivateComponent>
                  </Col>
                  {tabSLAs.invalids.regrasEscalacaoMessage.invalid && (
                    <Tooltip
                      title={tabSLAs.invalids.regrasEscalacaoMessage.message}
                      placement="bottom-start"
                    >
                      <span className="error-message">
                        {tabSLAs.invalids.regrasEscalacaoMessage.message}
                      </span>
                    </Tooltip>
                  )}
                  {tabSLAs.register?.regrasEscalacao &&
                    tabSLAs.register?.regrasEscalacao.map(
                      (_: RegraEscalacao, index: number) => (
                        <Col md={12} key={index}>
                          <Card className="d-flex flex-column gap-3 p-3">
                            <div className="d-flex justify-content-between align-items-center">
                              <Label className="label-12 mb-0">
                                Regra {index + 1}
                              </Label>
                              <IconButton
                                onClick={() => {
                                  onRemoveRegraEscalacao(index)
                                }}
                              >
                                <FiTrash className="icon" />
                              </IconButton>
                            </div>
                            <Row>
                              <Col md={6}>
                                <Label className="label-12">
                                  Disparar em (%)
                                </Label>
                                <InputCustom
                                  placeholder="%"
                                  value={
                                    tabSLAs.register?.regrasEscalacao[index]
                                      ?.disparaEm
                                  }
                                  onChange={(e) => {
                                    onChangeRegrasEscalacao(
                                      maskNumber(e.target.value),
                                      'disparaEm',
                                      index
                                    )
                                  }}
                                  invalid={
                                    tabSLAs.invalids.regrasEscalacao[index]
                                      .disparaEm.invalid
                                  }
                                  message={
                                    tabSLAs.invalids.regrasEscalacao[index]
                                      .disparaEm.message
                                  }
                                  disabled={tabSLAs.visualizacao}
                                />
                              </Col>
                              <Col md={6}>
                                <Label className="label-12">Ação</Label>
                                <CustomSelect
                                  options={tabSLAs.acoes}
                                  value={
                                    tabSLAs.register?.regrasEscalacao[index]
                                      ?.acaoId
                                  }
                                  onChange={(e) => {
                                    onChangeRegrasEscalacao(e, 'acaoId', index)
                                  }}
                                  accessorLabel="descricao"
                                  accessorValue="id"
                                  invalid={
                                    tabSLAs.invalids.regrasEscalacao[index]
                                      .acaoId.invalid
                                  }
                                  message={
                                    tabSLAs.invalids.regrasEscalacao[index]
                                      .acaoId.message
                                  }
                                  disabled={tabSLAs.visualizacao}
                                />
                              </Col>
                              <Col md={12}>
                                <Label className="label-12">Mensagem</Label>
                                <InputCustom
                                  placeholder="Mensagem de alerta..."
                                  value={
                                    tabSLAs.register?.regrasEscalacao[index]
                                      ?.mensagem
                                  }
                                  onChange={(e) => {
                                    onChangeRegrasEscalacao(
                                      e.target.value,
                                      'mensagem',
                                      index
                                    )
                                  }}
                                  invalid={
                                    tabSLAs.invalids.regrasEscalacao[index]
                                      .mensagem.invalid
                                  }
                                  message={
                                    tabSLAs.invalids.regrasEscalacao[index]
                                      .mensagem.message
                                  }
                                  disabled={tabSLAs.visualizacao}
                                />
                              </Col>
                            </Row>
                          </Card>
                        </Col>
                      )
                    )}
                </Row>
              </>
            ) : (
              <div className="d-flex flex-column gap-2">
                <Titulo>Selecione um SLA</Titulo>
                <div className="d-flex flex-column align-items-center justify-content-center gap-5 py-5">
                  <MdOutlineWatchLater size={40} />
                  <Info>Selecione um SLA para configurar</Info>
                </div>
              </div>
            )}
          </Card>
        </Col>
      </Row>
      <ModalExclusao
        isOpen={!!selectedId}
        toggle={() => {
          setSelectedId('')
        }}
        onRemove={() => {
          dispatch(
            configuracaoKanbanActions.removerSlaConfiguradoTabSLAsSaga(
              selectedId
            )
          )
          setSelectedId('')
        }}
        customMessage="Deseja realmente excluir este SLA?"
      />
    </div>
  )
}

export default SLAs
